export const timeToId = (p): string =>
  `${String(p.start_time).replace(':', '')}-${String(p.end_time).replace(':', '')}`
